import { render, staticRenderFns } from "./DeleteData.vue?vue&type=template&id=13b0eb8b&"
import script from "./DeleteData.vue?vue&type=script&lang=js&"
export * from "./DeleteData.vue?vue&type=script&lang=js&"
import style0 from "./DeleteData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports